import {
  Box,
  BoxContent,
  BoxSidebar,
  BoxSidebarItem,
  Heading,
} from '@mm/components';
import moment from 'moment';
import React, { useState } from 'react';
import { getDeviceInfo, getResolutionInfo } from '@mm/hooks';
import { PrimarySelectWithPush } from '../../../../../../common/components/PrimarySelect//PrimarySelectWithPush/PrimarySelectWithPush';
import { SIDEBAR_MENU } from '../../../../../../layout/BotBuilderSidebar/sidebar-menu';
import { NeedHelpLabel } from '../../../../common/components/NeedHelpLabel/NeedHelpLabel';
import { AnalyticsFilterByDate } from '../BotAnalytics/AnalyticsFilterByTime/AnalyticsFilterByDate';
import './ConversationAnalytics.scss';
import { AvgResponseTime } from './sectionsComponents/AvgTime/AvgTime';
import { BotAgentOutgoingChart } from './sectionsComponents/BotAgentOutgoingChart/BotAgentOutgoingChart';

export const ConversationAnalytics = () => {
  const [startDate, setStartDate] = useState<moment.Moment | null>(
    moment().subtract(14, 'days'),
  );
  const [endDate, setEndDate] = useState<moment.Moment | null>(moment());
  const [dateRangeMode, setDateRangeMode] = useState<string | null>(
    'Last 14 days',
  );
  const { isMobile } = getDeviceInfo();
  const { screenWidth } = getResolutionInfo();
  const menuOptions = SIDEBAR_MENU.filter(menu => menu.id === 'ANALYTICS')[0]
    ?.menuItems;

  return (
    <>
      {isMobile && screenWidth <= 600 && (
        <PrimarySelectWithPush
          options={menuOptions}
          value={menuOptions[1]}
          headerText="Analytics"
          customDropdownStyles={{ zIndex: '99' }}
        />
      )}
      <section className="conversation-analytics">
        <Box className="conversation-analytics__box">
          <BoxSidebar className="conversation-analytics__box-sidebar">
            <BoxSidebarItem>
              <div className="conversation-analytics__filter-heading-container">
                <Heading
                  className="conversation-analytics__filter-heading"
                  text="View by date"
                  size={4}
                />
                <NeedHelpLabel
                  iconOnly={true}
                  link="https://mobilemonkey.com/help/article/beo6r98ja4-analytics"
                />
              </div>
              <AnalyticsFilterByDate
                dateRangeMode={dateRangeMode}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                setDateRangeMode={setDateRangeMode}
              />
            </BoxSidebarItem>
          </BoxSidebar>
          <BoxContent className="conversation-analytics__sections">
            <BotAgentOutgoingChart
              startDate={startDate}
              endDate={endDate}
              dateRangeMode={dateRangeMode}
            />
            <div className="conversation-analytics_avg-time-container">
              <AvgResponseTime
                startDate={startDate}
                endDate={endDate}
                dateRangeMode={dateRangeMode}
              />
            </div>
          </BoxContent>
        </Box>
      </section>
    </>
  );
};
